import { Component, Input } from '@angular/core';
import { Capture } from '../../../core/models/capture.model';
import { PatientNameComponent } from '../../../shared/components/patient-name/patient-name.component';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-patient-details',
    templateUrl: './patient-details.component.html',
    styleUrls: ['./patient-details.component.scss'],
    imports: [PatientNameComponent, DatePipe]
})
export class PatientDetailsComponent {
  constructor() {}

  @Input() capture: Capture;
}
